import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

@Directive({
    selector: '[appTooltip]',
    standalone: false
})
export class TooltipDirective implements OnInit, OnDestroy {

  @Input("appTooltip") type: string = 'default';
  @Input() position: string = 'top'; // 'bottom', 'top', 'left', or 'right'
  @Input() xOffset: number = 0;
  @Input() yOffset: number = 0;
  @Input() width: number = 0;
  @Input() maxWidth: number = 0;
  @Input() linked?: string[]|string;
  linkedArray: string[] = [];
  //encStyle: "@",
  //encContent: "@",  
  //text: "@",
  //message: "@",
  //bind: "@",
  //calculated: "@",
  //format: "@"

  native: HTMLElement;
  triggerEl: Element|null = null;
  tooltipEl: Element|null = null;
  
  boundEnter: EventListenerOrEventListenerObject;
  boundLeave: EventListenerOrEventListenerObject;
  timeoutId?: any;

  constructor( el: ElementRef ) { 
      
      this.native = el.nativeElement;
      
      this.boundEnter = this.enter.bind( this );
      this.boundLeave = this.leave.bind( this );
      
  }
   
  ngOnInit(): void {
    
    for (let i = 0; i < this.native.children.length; i++) {
        const c = this.native.children.item(i);
       
        if (c && c.className.indexOf('trigger') > -1) {
            this.triggerEl = c;
        } else if (c && c.className.indexOf('tooltip') > -1) {
            this.tooltipEl = c;
            //c.remove(); // remove to be added back when trigger element is hovered
        }
    }
    
    if ( this.triggerEl ) {
        this.triggerEl.addEventListener( 'mouseenter', this.boundEnter );
        this.triggerEl.addEventListener( 'mouseleave', this.boundLeave );
    }
      
  }
   
  ngOnDestroy(): void {
     if ( this.triggerEl ) {
        this.triggerEl.removeEventListener( 'mouseenter', this.boundEnter );
        this.triggerEl.removeEventListener( 'mouseleave', this.boundLeave );
    }
  }
  
  enter(): void {
    
    if ( this.tooltipEl ) {
        
        let style = 'display:block;opacity:0;';
        
        if ( this.width ) {
            
            style += `width: ${this.width}px;`;
        }
        
        this.tooltipEl.setAttribute( 'style', style );
        
        setTimeout( () => {
            
           if ( typeof this.linked === 'string' ) {
               this.linkedArray = this.linked.split( ',' );
           } else if ( this.linked instanceof Array ) {
               this.linkedArray = this.linked;
           }
            
           //let style = 'display:block;';
            
            //if ( this.width ) {
                
                //style += `width: ${this.width}px;`;
                
                //this.tooltipEl.setAttribute( 'style', style );
            //}
            
            //this.native.appendChild( this.tooltipEl );
            
            if ( this.linkedArray.length ) {
                
                this.linkedArray.forEach( l => {
                   let el = document.getElementById( l ); 
                   
                   if ( el ) {
                       el.className += ' tooltip-linked';
                   } else {
                     // try looking up by class
                     const els = document.getElementsByClassName( l ); 
                     
                     for ( let i = 0; i < els.length; i++ ) {
                        
                        const e = els.item( i );
                        
                        if ( e ) {
                            e.className += ' tooltip-linked';
                        }
                     }
                   }
                });
            }
            
            let coords:{ top: number, left: number}|null = null;
            
            if ( this.position === 'bottom' ) {
                coords = this.calcBottomCoords();
            } else if ( this.position === 'top' ) {
                coords = this.calcTopCoords();
            } else if ( this.position === 'left' ) {
                coords = this.calcLeftCoords();
            } else if ( this.position === 'right' ) {
                coords = this.calcRightCoords();
            }
            
            if ( coords !== null && this.tooltipEl ) {
                
                style += `top: ${coords.top}px;left: ${coords.left}px;`;
                
                this.tooltipEl.setAttribute( 'style', style.replace('opacity:0', 'opacity:1')  );
            }
            
            this.timeoutId = setTimeout( () => (<Function>this.boundLeave)(), 10000 );
     }, 150);     
    }   
        
  }
  
  leave(): void {
      
      setTimeout( () => {
         if ( this.tooltipEl ) {
        //this.tooltipEl.remove();
            this.tooltipEl.removeAttribute( 'style')
          }
          
          if ( this.timeoutId ) {
              clearTimeout( this.timeoutId );
          }
          
          if ( this.linkedArray.length ) {
            this.linkedArray.forEach( l => {
               const el = document.getElementById( l ); 
               
               if ( el ) {
                   el.className = el.className.replace( ' tooltip-linked', '' );
               } else {
                  // try looking up by class
                  const els = document.getElementsByClassName( l ); 
                    
                  for ( let i = 0; i < els.length; i++ ) {
                       
                     const e = els.item( i );
                      
                     if ( e ) {
                       e.className = e.className.replace( ' tooltip-linked', '' );
                     }
                  }
                }
            });
          } 
      }, 200);  
    
  }
  
    private calcTopCoords(): { top: number, left: number}|null {
                       
        if ( this.triggerEl && this.tooltipEl ) {
            var triggerElOffset = this.triggerEl.getBoundingClientRect();
            var coords = { left: 0, top: 0 };
            
            coords.left = (triggerElOffset.left + (this.triggerEl.clientWidth / 2) - 
                    (this.tooltipEl.clientWidth / 2) + this.xOffset);
            
            if (coords.left < 0) {
                coords.left = 0;
            }
            
            if (window.visualViewport?.width && 
                coords.left + this.tooltipEl.clientWidth > window.visualViewport?.width) {
             
                coords.left = window.visualViewport?.width - this.tooltipEl.clientWidth - 5;
                    
            }
            
            coords.top = (triggerElOffset.top - this.tooltipEl.clientHeight - 
                (this.yOffset || 10));
            
            return coords;
        }                
        
        return null;
    }
    
    private calcRightCoords(): { top: number, left: number}|null {
        
        if ( this.triggerEl && this.tooltipEl ) {
            var triggerElOffset = this.triggerEl.getBoundingClientRect();
            var coords = { left: 0, top: 0 };
            
            coords.left = (triggerElOffset.right + this.xOffset);
            
            coords.top = (triggerElOffset.top + (this.triggerEl.clientHeight / 2)
                     - (this.tooltipEl.clientHeight / 2) - this.yOffset);
                     
            return coords;
        }
        
        return null;
    }
    
    private calcBottomCoords(): { top: number, left: number}|null {
        
        if ( this.triggerEl && this.tooltipEl ) {
            var triggerElOffset = this.triggerEl.getBoundingClientRect();
            var coords = { left: 0, top: 0 };
            
            coords.left = (triggerElOffset.left + (this.triggerEl.clientWidth / 2) - 
                    (this.tooltipEl.clientWidth / 2) + this.xOffset);
                    
            if ( coords.left < 0 ) {
                coords.left = 0;
            }
            
            coords.top = (triggerElOffset.top + this.triggerEl.clientHeight + this.yOffset);
            
            return coords;
        }
        return null;
    }
    
    private calcLeftCoords(): { top: number, left: number}|null {
        
        if ( this.triggerEl && this.tooltipEl ) {
            var triggerElOffset = this.triggerEl.getBoundingClientRect();
            var coords = { left: 0, top: 0 };
            
            coords.left = (triggerElOffset.left - 
                this.tooltipEl.clientWidth - 
                ( this.xOffset ? this.xOffset : 10 ) );
            
            coords.top = (triggerElOffset.top + (this.triggerEl.clientHeight / 2)
                     - (this.tooltipEl.clientHeight / 2) - this.yOffset);
            
            return coords;
        }
        return null;
    }

}